import React from 'react';
import { CCard, CCardHeader, CCardBody, CRow, CCol, CCardTitle, CTooltip, CImg } from '@coreui/react';
import ColorPicker from '../../shared/components/form/ColorPicker/ColorPicker';
import tooltip from '../../assets/images/tool_tip.svg';

const ColorsPickerForm = () => {
  return (
    <CCard className="glympser-container--roundedWithShadow">
      <CCardHeader className="glympser-roundedTop">
        <div className="d-flex align-items-center justify-content-between">
          <CCardTitle className="m-0">
            Colors
            <CTooltip placement="top"
                      content="Set the primary and secondary colors for the link sent to customers. Use Preview to see the result.">
              <CImg src={tooltip} className="ml-2 glympser-toolTip" />
            </CTooltip>
          </CCardTitle>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <ColorPicker name="primary" />
          </CCol>
          <CCol>
            <ColorPicker name="secondary" />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};


export default ColorsPickerForm;
